import React from 'react';
import ReactDOM from 'react-dom/client';
import AppRouter from './AppRouter';
import ErrorBoundary from './components/common/ErrorBoundary';

// 全局样式
import 'antd/dist/reset.css';
import './App.css';

const el = document.getElementById('root');
if (!el) {
  throw new Error('Missing #root element');
}

ReactDOM.createRoot(el).render(
  <ErrorBoundary>
    <AppRouter />
  </ErrorBoundary>
);






